import {inject, Pipe, PipeTransform} from '@angular/core';
import {DexSecuritiesSubjectService} from '../dex/dex-streaming/subjects/dex-securities-subject-service';
import {ValueWithDelDp} from '../dex/dex-streaming/utils';
import {addCurrencyToDisplayDecimal, DisplayDecimalWithOptCurrency} from '../symbol-decimals';
import {createDisplayDecimalFromBigint} from '../symbol-decimals/display-decimal-bigint';

@Pipe({
    name: 'valueWithDelDisplayDecimal'
})
export class ValueWithDelDisplayDecimalPipe implements PipeTransform {

    private prevDp: number | undefined;
    private prevValue: bigint | undefined;
    private prevResult: DisplayDecimalWithOptCurrency<string>;

    private readonly dexSecuritiesSubjectService = inject(DexSecuritiesSubjectService);

    public transform(
        value: ValueWithDelDp | undefined,
        showCurrency: boolean = true
    ): DisplayDecimalWithOptCurrency<string> {
        const dp = value ? value.dp ?? value.d?.decimalPlaces : undefined;
        const v = value?.v;

        const displayDecimal: DisplayDecimalWithOptCurrency<string> = (dp === this.prevDp && v === this.prevValue)
            ? this.prevResult
            : createDisplayDecimalFromBigint(v, dp);

        if (displayDecimal) {
            if (value?.d && showCurrency) {
                const symbol = this.dexSecuritiesSubjectService.getDelDisplaySymbol(value.d);

                addCurrencyToDisplayDecimal(displayDecimal, symbol);
            } else if (displayDecimal?.currencySymbol) {
                displayDecimal.currencySymbol = undefined;
            }
        }

        this.prevDp = dp;
        this.prevValue = v;
        this.prevResult = displayDecimal;

        return displayDecimal;
    }

}
